export const ProjectData=[
    {
        id:1,
        title:"Food_Delivery ChatBot",
        about: "It is an automatic bot using Python and PyCharm to perform ordering and delivering of food.Implemented Dialogflow AI technology to develop an interactive chatbot on the company website, resulting in a 40% increase in customer engagement and a 25% decrease in average response time. ",
        tags:["HTML5", "CSS", "JavaScript" , "DialogFlow", "Python", "MySQL","PyCharm"],
        demo:"https://t.me/Big_Friday_Bot",
        github:"https://github.com/Abhishek2000Singh/FoodDeliveryChatBot",
        image:"",
    },
    {
        id:1,
        title:"Movie_Recommendation_System",
        about: " It is  a machine learning-based method for filtering or forecasting user preferences for movies based on their browsing history and other behavior. Processed data entered by the user at the application's back end to provide a suggested search.",
        tags:["Python","Jupyter" ,"StreamLit", "Pandas" , "Numpy", "Pickle", "Responsive"],
        demo:"https://github.com/Abhishek2000Singh/MovieRecommenderSystem.github.io",
        github:"https://github.com/Abhishek2000Singh/MovieRecommenderSystem.github.io",
        
    },
    {
        id:1,
        title:"Craft-For-Fund",
        about: "It is a great initiative to work for Humanity. The main purpose of CraftForFund is to serve needy people to get helped on online platform and it connects Entrepreneurs, Medical seekers, Individuals, Business groups, Students and Organizations with group of Moneylenders willing to contribute money to support impactful initiatives and meaningful projects.",
        tags:["Javascript", "ReactJS", "NodeJS", "ExpressJS" , "MongoDB", "Vercel", "Responsive", "CloudFlare AI", "ChatBot"],
        demo:"https://craftforfund.vercel.app/",
        github:"https://github.com/Abhishek2000Singh/Main---craftForFund",
        
    },
    {
        id:1,
        title:"Library Management System",
        about: "It is a Library Management System using Java to simulate the common functions of using a library system. Used MySQL to create a database that stores the data of student and admin such as creating an account, requesting new books, issuing date, list of all books , etc. Implemented object-oriented programming practices such as inheritance to create different account types and databases.",
        tags:["Java", "HTML5", "CSS3", "Github Pages","MySQL"],
        demo:"https://github.com/Abhishek2000Singh/LibraryManagementSystem.github.io",
        github:"https://github.com/Abhishek2000Singh/LibraryManagementSystem.github.io",
    },
    {
        id:1,
        title:"Guessing_The_Number Game",
        about: "Develop a classic GuessingTheNumber game using java program. Enable to guess the number, with responsive design for seamless experience across devices. Incorporate win detection logic for an engaging and competitive experience.",
        tags:[ "Java", "Github Pages"],
        demo:"https://github.com/Abhishek2000Singh/GuessingTheNumber.github.io",
        github:"https://github.com/Abhishek2000Singh/GuessingTheNumber.github.io",
    }
];